export default __webpack_public_path__ + "svg/CompaniesLogos/logo_sakudarte.svg?1ed63643";